import Client from 'config/axios';

export const getSecret2FA = async (token: string) => {
  return await Client.get('get-QR-secret-2FA', {
    headers: {
      'Content-type': 'application/json',
      Authorization: `Bearer ${token}`
    }
  })
    .then(response => response.data.data)
    .catch(error => error);
};
